export const POST_PROMOTED_VIDEO = "POST_PROMOTED_VIDEO";
export const GET_PROMOTED_VIDEO = "GET_PROMOTED_VIDEO";
export const SHOW_PROMOTED_VIDEO = "SHOW_PROMOTED_VIDEO";
export const UPDATE_PROMOTED_VIDEO = "UPDATE_PROMOTED_VIDEO";
export const UPDATE_STATUS_PROMOTED_VIDEO = "UPDATE_STATUS_PROMOTED_VIDEO";